module.exports = __webpack_public_path__ + "static/img/man1.6e9bad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HumanPic/man1.png
// module id = Ry30
// module chunks = 2